import {IAccVoucherVm,} from "../../../model/respone/category/IAccVoucher";
import {generateActionTypeIds} from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eAccVoucherActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IAccVoucherVm[],
    LOAD_ERRR: "",

    SAVE_START: {} as IAccVoucherVm,
    SAVE_SUCCESS: {} as IAccVoucherVm,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    SHOW_EDIT_MODAL: {} as undefined | IAccVoucherVm,
    CLOSE_EDIT_MODAL: undefined,

    SELECTED_ID: [] as number[],
    DELETE_MANY_START: [] as number[],
    DELETE_MANY_SUCCESS: undefined,
    DELETE_MANY_ERROR: "",

    CHECK_VOUCHER_CHANGE_START: {} as IAccVoucherVm,
    CHECK_VOUCHER_CHANGE_SUCCESS: {} as IAccVoucherVm,
    CHECK_VOUCHER_CHANGE_ERROR: "",
};
export const eAccVoucherActionIds = generateActionTypeIds(
    eAccVoucherActionsObj,
    "VOUCHER"
);
export type IAccVoucherActionTypes = IGenericActionType<
    typeof eAccVoucherActionsObj,
    "VOUCHER"
>;
